import Vue from 'vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import Flow from 'vux/src/components/flow/flow.vue'
import FlowState from 'vux/src/components/flow/flow-state.vue'
import FlowLine from 'vux/src/components/flow/flow-line.vue'
import Picker from 'vux/src/components/picker/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import Scroller from 'vux/src/components/scroller/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

Vue.component('x-button', XButton)
Vue.component('scroller', Scroller)
Vue.component('flow', Flow)
Vue.component('flow-state', FlowState)
Vue.component('flow-line', FlowLine)
Vue.component('picker', Picker)
Vue.component('confirm', Confirm)
Vue.component('alert', Alert)
Vue.component('loading', Loading)
Vue.component('inline-loading', InlineLoading)
Vue.component('toast', Toast)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)


// WEBPACK FOOTER //
// ./src/public/vuxPublicCom.js